import {
	ADD_AGENDA_FAIL,
	ADD_AGENDA_START,
	ADD_AGENDA_SUCCESS,
	ADD_STORICO_PRENOTAZIONE_FAIL,
	ADD_STORICO_PRENOTAZIONE_START,
	ADD_STORICO_PRENOTAZIONE_SUCCESS,
	CREATE_TAMPONE_FAIL,
	CREATE_TAMPONE_START,
	CREATE_TAMPONE_SUCCESS,
	GET_ALL_AGENDE_FAIL,
	GET_ALL_AGENDE_START,
	GET_ALL_AGENDE_SUCCESS,
	GET_INFO_PRENOTAZIONI_FAIL,
	GET_INFO_PRENOTAZIONI_START,
	GET_INFO_PRENOTAZIONI_SUCCESS,
	GET_PRENOTAZIONE_FAIL,
	GET_PRENOTAZIONE_START,
	GET_PRENOTAZIONE_SUCCESS,
	GET_TAMPONI_BY_MONTH_FAIL,
	GET_TAMPONI_BY_MONTH_START,
	GET_TAMPONI_BY_MONTH_SUCCESS,
	GET_STORICO_PRENOTAZIONE_FAIL,
	GET_STORICO_PRENOTAZIONE_START,
	GET_STORICO_PRENOTAZIONE_SUCCESS,
	GET_TAMPONE_BY_ID_FAIL,
	GET_TAMPONE_BY_ID_START,
	GET_TAMPONE_BY_ID_SUCCESS,
	PRENOTA_TAMPONE_FAIL,
	PRENOTA_TAMPONE_START,
	PRENOTA_TAMPONE_SUCCESS,
	SEND_PDF_FAIL,
	SEND_PDF_START,
	SEND_PDF_SUCCESS,
	UPDATE_PRENOTAZIONE_FAIL,
	UPDATE_PRENOTAZIONE_START,
	UPDATE_PRENOTAZIONE_SUCCESS,
	UPDATE_TAMPONE_FAIL,
	UPDATE_TAMPONE_START,
	UPDATE_TAMPONE_SUCCESS,
	GET_TAMPONI_BY_DAY_START,
	GET_TAMPONI_BY_DAY_SUCCESS,
	GET_TAMPONI_BY_DAY_FAIL,
	RESET_TAMPONI_DAY,
} from "../reducers/actions/ActionTypes";
import axios from "axios";
import {
	ADD_AGENDA_URL, ADD_STORICO_PRENOTAZIONE_URL,
	CREATE_TAMPONE_URL, GET_ALL_AGENDE_URL, GET_ALL_INFO_PRENOTAZIONE_URL,
	GET_ALL_PRENOTAZIONI_URL, GET_TAMPONI_BY_MONTH_URL, GET_STORICO_PRENOTAZIONE_URL, GET_TAMPONE_BY_ID_NO_AUTH_URL,
	GET_TAMPONE_BY_ID_URL,
	PRENOTA_TAMPONE_URL, SEND_PDF_PRENOTAZIONI_URL, UPDATE_PRENOTAZIONE_URL, UPDATE_TAMPONE_URL, GET_ALL_TAMPONI_URL
} from "./utils/ApiUrls";
import {getErrorMessage} from "../reducers/utils/ReducerUtils";
import {getConfig} from "./utils/ConfigUtils";
import {authLogout} from "./AuthServices";
import moment from "moment";
import {endOfMonth, startOfMonth} from "date-fns";


export function getTamponeById(id, dispatch) {
	dispatch({type: GET_TAMPONE_BY_ID_START});
	axios
		.get(GET_TAMPONE_BY_ID_URL + id, getConfig())
		.then((response) => {
			if (response.status === 226) {
				authLogout();
			} else {
				dispatch({type: GET_TAMPONE_BY_ID_SUCCESS, payload: response.data});
			}
		})
		.catch((error) => dispatch({type: GET_TAMPONE_BY_ID_FAIL, error: getErrorMessage(error)}))
}

export function getTamponeByIdNoAuth(id, dispatch) {
	dispatch({type: GET_TAMPONE_BY_ID_START});
	axios
		.get(GET_TAMPONE_BY_ID_NO_AUTH_URL + id)
		.then((response) => {
			dispatch({type: GET_TAMPONE_BY_ID_SUCCESS, payload: response.data});
		})
		.catch((error) => dispatch({type: GET_TAMPONE_BY_ID_FAIL, error: getErrorMessage(error)}))
}

export function prenotaTampone(tampone, dispatch) {
	dispatch({type: PRENOTA_TAMPONE_START});
	axios
		.post(PRENOTA_TAMPONE_URL, tampone, getConfig())
		.then((response) => {
			if (response.status === 226) {
				authLogout();
			} else {
				dispatch({type: PRENOTA_TAMPONE_SUCCESS, payload: response.data})
			}
		})
		.catch((error) => dispatch({type: PRENOTA_TAMPONE_FAIL, error: getErrorMessage(error)}))
}

export function updateTampone(tampone, dispatch) {
	dispatch({type: UPDATE_TAMPONE_START});
	axios
		.post(UPDATE_TAMPONE_URL, tampone, getConfig())
		.then(() => dispatch({type: UPDATE_TAMPONE_SUCCESS, payload: tampone}))
		.catch((error) => dispatch({type: UPDATE_TAMPONE_FAIL, error: getErrorMessage(error)}))
}

export function resetUpdateTampone(dispatch) {
	dispatch({type: UPDATE_TAMPONE_START});
}

export function getPrenotazioneById(idPrenotazione, dispatch) {
	dispatch({type: GET_PRENOTAZIONE_START});
	axios
		.post(GET_ALL_PRENOTAZIONI_URL + "0/dataRichiesta/ASC", {id: idPrenotazione}, getConfig())
		.then((response) => dispatch({type: GET_PRENOTAZIONE_SUCCESS, payload: response.data?.[0]}))
		.catch((error) => dispatch({type: GET_PRENOTAZIONE_FAIL, error: getErrorMessage(error)}))
}

export function updatePrenotazione(prenotazione, dispatch) {
	console.log("#2")
	console.log(prenotazione)
	dispatch({type: UPDATE_PRENOTAZIONE_START});
	axios
		.post(UPDATE_PRENOTAZIONE_URL + prenotazione.id, prenotazione, getConfig())
		.then(() => {
			console.log("#3")
			console.log(prenotazione)
			dispatch({type: UPDATE_PRENOTAZIONE_SUCCESS})
		})
		.catch((error) => {
			console.log("#4")
			console.log(prenotazione)
			dispatch({type: UPDATE_PRENOTAZIONE_FAIL, error: getErrorMessage(error)})
		})
}

export function createTampone(tampone, dispatch) {
	dispatch({type: CREATE_TAMPONE_START});
	axios
		.post(CREATE_TAMPONE_URL, tampone, getConfig())
		.then(() => dispatch({type: CREATE_TAMPONE_SUCCESS}))
		.catch((error) => dispatch({type: CREATE_TAMPONE_FAIL, error: getErrorMessage(error)}))
}

export function creaAgendaPrenotazioni(data, dispatch) {
	dispatch({type: ADD_AGENDA_START});
	axios
		.post(ADD_AGENDA_URL, data, getConfig())
		.then(() => dispatch({type: ADD_AGENDA_SUCCESS}))
		.catch((error) => dispatch({type: ADD_AGENDA_FAIL, error: getErrorMessage(error)}))
}

export function getAllAgende(data, dispatch) {
	dispatch({type: GET_ALL_AGENDE_START});
	axios
		.post(GET_ALL_AGENDE_URL, data, getConfig())
		.then((response) => dispatch({type: GET_ALL_AGENDE_SUCCESS, payload: response.data}))
		.catch((error) => dispatch({type: GET_ALL_AGENDE_FAIL, error: getErrorMessage(error)}))
}

export function getStoricoPrenotazione(idPrenotazione, dispatch) {
	dispatch({type: GET_STORICO_PRENOTAZIONE_START});
	axios
		.get(GET_STORICO_PRENOTAZIONE_URL + idPrenotazione, getConfig())
		.then((response) => dispatch({type: GET_STORICO_PRENOTAZIONE_SUCCESS, payload: response.data}))
		.catch((error) => dispatch({type: GET_STORICO_PRENOTAZIONE_FAIL, error: getErrorMessage(error)}))
}

export async function getStoricoPrenotazioneArray(idPrenotazione, callback) {
	await axios
		.get(GET_STORICO_PRENOTAZIONE_URL + idPrenotazione, getConfig())
		.then((response) => callback(response.data))
		.catch((error) => console.log(getErrorMessage(error)))
}

export function addStoricoPrenotazione(data, dispatch) {
	dispatch({type: ADD_STORICO_PRENOTAZIONE_START});
	axios
		.post(ADD_STORICO_PRENOTAZIONE_URL, {
			...data,
			motivazione: (data.motivazione && data.motivazione.includes("Prioritaria")) ? "Prioritaria" : null
		}, getConfig())
		.then(() => dispatch({type: ADD_STORICO_PRENOTAZIONE_SUCCESS}))
		.catch((error) => dispatch({type: ADD_STORICO_PRENOTAZIONE_FAIL, error: getErrorMessage(error)}))
}

export function getInfoPrenotazioni(dispatch, data) {
	dispatch({type: GET_INFO_PRENOTAZIONI_START});
	axios
		.get(GET_ALL_INFO_PRENOTAZIONE_URL + '?tipo=' + data.tipo, getConfig())
		.then((response) => dispatch({type: GET_INFO_PRENOTAZIONI_SUCCESS, payload: response.data}))
		.catch((error) => dispatch({type: GET_INFO_PRENOTAZIONI_FAIL, error: getErrorMessage(error)}))
}

export function sendPDF(data, dispatch) {
	dispatch({type: SEND_PDF_START})
	axios
		.get(SEND_PDF_PRENOTAZIONI_URL + data, getConfig())
		.then(() => dispatch({type: SEND_PDF_SUCCESS}))
		.catch((error) => dispatch({type: SEND_PDF_FAIL, error: getErrorMessage(error)}))
}

export function getAllTamponiByMonth(month, dispatch) {
	dispatch({type: GET_TAMPONI_BY_MONTH_START});
	axios
		.get(GET_TAMPONI_BY_MONTH_URL + moment(startOfMonth(month)).format("DD-MM-YYYY") + "/" + moment(endOfMonth(month)).format("DD-MM-YYYY"), getConfig())
		.then((response) => {
			let map = {
				dg: {},
				gg: {},
				ii: {},
				pr: {},
				cc: {}
			}
			try {
				console.log(response.data);

				if (response.data["Da gestire"]) {
					Object.entries(response.data["Da gestire"])?.forEach(([key, val]) => {
						map.dg[new Date(key)] = val
					})
				}

				if (response.data["Gestito - Operatore"]) {
					Object.entries(response.data["Gestito - Operatore"])?.forEach(([key, val]) => {
						map.gg[new Date(key)] = val
					})
				}

				if (response.data["Irreperibile"]) {
					Object.entries(response.data["Irreperibile"])?.forEach(([key, val]) => {
						map.ii[new Date(key)] = val
					})
				}

				if (response.data["Preso in carico"]) {
					Object.entries(response.data["Preso in carico"])?.forEach(([key, val]) => {
						map.pr[new Date(key)] = val
					})
				}

				if (response.data["Gestito - Cittadino"]) {
					Object.entries(response.data["Gestito - Cittadino"])?.forEach(([key, val]) => {
						map.cc[new Date(key)] = val
					})
				}

			} catch (e) {
				console.log(e)
			}

			console.log(map)

			dispatch({type: GET_TAMPONI_BY_MONTH_SUCCESS, payload: map})
		})
		.catch((error) => dispatch({type: GET_TAMPONI_BY_MONTH_FAIL, error: getErrorMessage(error)}))
}

export function getTamponiByEndDay(data, dispatch, page) {
	dispatch({type: GET_TAMPONI_BY_DAY_START});
	axios
		.post(GET_ALL_TAMPONI_URL + page + "/dataEsito/ASC", data, getConfig())
		.then((response) => dispatch({type: GET_TAMPONI_BY_DAY_SUCCESS, payload: response.data}))
		.catch((error) => dispatch({type: GET_TAMPONI_BY_DAY_FAIL, error: getErrorMessage(error)}))
}

export function resetTamponiDay(dispatch) {
	dispatch({type: RESET_TAMPONI_DAY});
}
